// Convert a CSV string to XLXS buffer 
// change from xlxs/xls and other formats by going through sheetsjs documentation.
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

export function convertCsvToExcelBuffer (csvString) {
  const arrayOfArrayCsv = csvString.split("\n").map((row) => {
    return row.split(",")
  });
  const wb = XLSX.utils.book_new();
  const newWs = XLSX.utils.aoa_to_sheet(arrayOfArrayCsv);
  XLSX.utils.book_append_sheet(wb, newWs);
  const rawExcel = XLSX.write(wb, { type: 'base64' })
  return rawExcel
}

export function exportAsExcel(dataBlob, fileName) {
    // let dataBlob = '...kAAAAFAAIcmtzaGVldHMvc2hlZXQxLnhtbFBLBQYAAAAACQAJAD8CAADdGAAAAAA='; // If have ; You should be split get blob data only
    downloadFile(dataBlob, fileName);
}

function downloadFile(blobContent, fileName){
    let blob = new Blob([base64toBlob(blobContent, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')], {});
    FileSaver.saveAs(blob, fileName);
}

function base64toBlob(base64Data, contentType) {
  contentType = contentType || '';
  let sliceSize = 1024;
  let byteCharacters = atob(base64Data);
  let bytesLength = byteCharacters.length;
  let slicesCount = Math.ceil(bytesLength / sliceSize);
  let byteArrays = new Array(slicesCount);
  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin + sliceSize, bytesLength);

      let bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
}

export function cleanCSV(csv) {
  // var csv = '"acb"\n"fhk"';
  let rows = csv.split('\n');
  rows = rows.map(row => { return row.replace(/"/g, ''); });
  // const header = rows.shift().replace(/"/g, '');
  // rows.unshift(header);
  csv = rows.join('\n');
  return csv;
}